export default {
  props: {
    isLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    isDisabled: {
      type: Boolean,
      required: false,
      default: false
    },
    onSubmit: {
      type: Function,
      required: true
    },
    FormData: {
      type: Object,
      required: false
    },
    DisabledFields: {
      type: Object,
      required: false
    },
    ButtonLabel: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      fData: {},
      disabledFields: {}
    }
  },
  created () {
    if (this.FormData) {
      this.fData = { ...this.fData, ...this.FormData }
    }
    if (this.DisabledFields) {
      this.disabledFields = { ...this.disabledFields, ...this.DisabledFields }
    }
  },
  watch: {
    FormData (data) {
      if (data) {
        this.fData = { ...this.fData, ...data }
      }
    },
    DisabledFields (data) {
      if (data) {
        this.disabledFields = { ...this.disabledFields, ...data }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/forms/FormMixin.js